import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UtiBox from "./box/UtiBox";
import chart from "../../assets/images/chart.svg";
import chartMobile from "../../assets/images/chartMobile.svg";

import start from "../../assets/images/start.svg";
import startMobile from "../../assets/images/startMobile.svg";
import end from "../../assets/images/end.svg";
import endMobile from "../../assets/images/endMobile.svg";

import truck from "../../assets/images/truck.svg";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";

import "./ChartStatus.css";
import { ConstructionOutlined } from "@mui/icons-material";

function ChartStatus(props) {
  const {data}=useSelector((state)=>state.data)
  const isMobile = window.innerWidth <= 760;
  console.log(props);
  const trackWidth = !isMobile ? 100 : 83;
  const createTruckPostion = (step, percent) => {
    // const firstStep=7
    step = props.data?.step;
    percent = props.data?.innerPercentage;
    let numberOfSteps = props.data?.numberOfSteps;
    
    let stepPercentage = 74 / numberOfSteps;
    let percentPercentage = 72 / numberOfSteps;
    let chart = (step - 1) * stepPercentage + percent * percentPercentage + 3;
    chart = isMobile ? chart - 6 : chart - 3;

    return chart;
  };
  const [truckPosition, setTruckPosition] = useState(
    createTruckPostion(props.data?.step, props.data?.innerPercentage)
  );

  return (
    <div dir="rtl" className="chart-warp">
      {props?.data?.shiduhDate && (
        <>
          <img className="start" src={!isMobile ? start : startMobile} />
          <span className="start-text">{props.data?.shiduhDate}</span>
        </>
      )}
      {props?.data?.deliveryExpected && (
        <>
          <img className="end" src={!isMobile ? end : endMobile} />
          <span className="end-text">{props.data?.deliveryExpected}</span>
        </>
      )}
      <img
        className="truck"
        style={{ right: createTruckPostion(props.data?.step) + "vw" }}
        src={truck}
      />
      <img className="chart" src={!isMobile ? chart : chartMobile} />
      <span
        className="active-line"
        style={{
          width:
            "calc(" +
            createTruckPostion(props.data?.step) +
            "vw  +  " +
            trackWidth +
            "px)",
        }}
      ></span>

      {((props.data?.deliveryDate && props.data?.deliveryDate?.indexOf('טרם') === -1) || data?.currentPosition  || props.data?.daysLeft) ? (
      <>
          {!isMobile && data?.currentPositionDate && data?.currentPosition && (
            <div className={"desc-box" + (data?.deleveryFinalDate ? " delivered" : "")} style={{ right: createTruckPostion(props.data?.step) + "vw"}}>
              {!data?.deleveryFinalDate && 
                <div className="row">
                  <LocationOnIcon />
                  <div>
                    {data?.currentPositionDate && <span className="box-title">{data?.currentPositionDate}</span>}
                    {data?.currentPosition && <span className="box-value"> {data?.currentPosition}</span>}
                  </div>
                </div>
              }
              {!data?.deleveryFinalDate && 
                <div className="Line-645"></div>
              }
              {data?.deleveryFinalDate && 
                <div className="row delivery">
                  <div>
                    <span className="box-value">נמסר</span>
                  </div>
                </div>
              }
              {data?.daysLeft !== null && data?.daysLeft>0 && 
              <div className="row">
                <AccessTimeFilledIcon />
                <div>
                  <span className="box-title">צפי אספקה</span>
                  <span className="box-value"><span className="daysLeft">{data?.daysLeft}</span>ימים</span>
                </div>
              </div>
              }
        </div>
      )}
      {isMobile && data?.daysLeft>0 && <div className="desc-box-mobile">צפי אספקה  <span className="daysLeft">{data?.daysLeft}</span> ימים</div>}
      </>): ''}
    </div>
  );
}

export default ChartStatus;
